import PromModel from '@/models/Prom';

const GET_MY_COUPON_LIST = 'GET_MY_COUPON_LIST';
const GET_ORDER_COUPON_LIST = 'GET_ORDER_COUPON_LIST';

/**
 * 获取我的优惠券列表
 * @param {Number} couponStatus 优惠券状态 1-未使用 2-已使用 4-已过期
 */
async function getMyCouponList(couponStatus) {
  const payload = await new PromModel().myCouponList(couponStatus);
  return {
    type: GET_MY_COUPON_LIST,
    payload
  }
}

/**
 * 获取订单可用优惠券
 * @param {string} spuNo
 * @param {number} tradeAmount 订单总金额
 */
async function getOrderCouponList({ spuNo, tradeAmount }) {
  const payload = await new PromModel().orderCouponList({ spuNo, tradeAmount });
  return {
    type: GET_ORDER_COUPON_LIST,
    payload
  }
}

const ACTION_TYPES = {
  GET_MY_COUPON_LIST,
  GET_ORDER_COUPON_LIST,
};

const ACTION = {
  getMyCouponList,
  getOrderCouponList,
};

const CouponList = {
  ACTION_TYPES,
  ACTION
}

export default CouponList;